<template>
  <div class="yedeklemeler">
    <AppMain>


      <div class="container-fluid">
        <div class="row">
          <div class="col-xxl-12">
            <div class="inner-contents">





              <div class="nk-block-head nk-block-head-sm">
                <div class="nk-block-between">
                  <div class="nk-block-head-content">
                    <h3 class="nk-block-title page-title">Yedeklemeler</h3>
                    <div class="nk-block-des text-soft">
                      <p>Tfon Makine</p>
                    </div>
                  </div>
                  <div class="nk-block-head-content">
                    <div class="toggle-wrap nk-block-tools-toggle"><a href="#"
                        class="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em
                          class="icon ni ni-menu-alt-r"></em></a>
                      <div class="toggle-expand-content" data-content="pageMenu">
                        <ul class="nk-block-tools g-3">

                          <li><a href="#" v-if="yetki_kontrol('yedek_ekle')" @click="yedekindir"
                              class="btn btn-white btn-outline-light"><em
                                class="icon ni ni-download-cloud"></em><span>Yedek İndirin</span></a>
                          </li>

                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>





              <div class="row mt-3">


                <div class="col-12 col-lg-8">


                  <div class="card card-bordered mb-1" v-for="yedek in yedekler" :key="yedek.ad">
                    <div class="project p-2">

                      <div class="project-center">
                        <div class="project-head d-flex justify-content-between">
                          <p class="title">{{ yedek.ad }}</p>
                          <div class="drodown">
                            <a :href="yedek.url" target="_blank" class="btn btn-soft btn-outline-info"> İndir</a>
                          </div>
                        </div>


                      </div>

                    </div>
                  </div>














                </div>
                <div class="col-12 col-lg-4">

                  <div class="card">
                    <div class="card-body">
                      <h5 class="card-title">Yedek Yükle</h5>
                      <h6 class="card-subtitle mb-2 text-muted">Yedek Yüklerken Tüm veriler Silinip yedek Verileri Yüklenir</h6>
                      <div class="form-group">
                          <label for="sql">Veritabanı (*.sql):</label>
                          <input type="file" class="form-control" id="sql" name="sql" accept=".sql"
                            v-on:change="dosyaSecSql" />
                        </div>
                        <div class="form-group">
                          <label for="dosyalar">Dosyalar (*.zip):</label>
                          <input type="file" class="form-control" id="dosyalar" name="dosyalar" accept=".zip"
                            v-on:change="dosyaSecDosyalar" />
                        </div>

                        <div class="progress" v-if="isUploading">
                          {{ uploadFileName }} Dosyası Yükleniyor
                          <div class="progress-bar" role="progressbar" :style="{ width: `${uploadProgress}%` }">
                            {{ uploadProgress }}%
                          </div>
                        </div>



                        <br>
                        <button class="btn btn-primary w-100" @click="sqlyukle">Kaydet</button>
                    </div>
                  </div>


                 

                </div>


              </div>
            </div>
          </div>
        </div>
      </div>
    </AppMain>
  </div>
</template>

<script>
import axiosCustom from "@/services/axiosCustom";
import { yetkiKontrol } from '@/services/yetkiKontrol';
import AppMain from "@/components/AppMain.vue";




export default {
  name: "yedeklerView",
  components: {
    AppMain,
  },
  data() {
    return {
      yedekler: [],



      isUploading: false,
      uploadFileName: '',
      uploadProgress: 0,
      seciliDosyalar: [],
      sqlislemadim: 0,
      sqlprosesbar: 0,

    };
  },


  mounted() {
    this.yedeklerGetir();
  },
  methods: {
    yetki_kontrol(yetki) {
      return yetkiKontrol(yetki);
    },

    yedekindir() {
      axiosCustom
        .get("yedekler/yedekindir")
        .then((response) => {
          window.location.href = response.data.sql;

          setTimeout(() => {
            window.location.href = response.data.zip;
          }, 1000);

          this.$toast.success("Yedek İndirildi.");
        })
        .catch((error) => {
          console.error("Yedek İndirme Hatası: ", error);
        });
    },
    yedeklerGetir() {
      axiosCustom
        .get("yedekler")
        .then((response) => {
          this.yedekler = response.data;

        })
        .catch((error) => {
          console.error("Yedek Hatası: ", error);
        });
    },



    dosyaSecSql(event) {
      this.seciliDosyalar[0] = event.target.files[0];
    },
    dosyaSecDosyalar(event) {
      this.seciliDosyalar[1] = event.target.files[0];
    },

    async sqlyukle() {

      const CHUNK_SIZE = 1024 * 1024; // 1 MB
      const totalFiles = this.seciliDosyalar.length;
      let uploadedFiles = 0;

      for (const file of this.seciliDosyalar) {
        const totalChunks = Math.ceil(file.size / CHUNK_SIZE);

        for (let chunk = 0; chunk < totalChunks; chunk++) {
          const start = chunk * CHUNK_SIZE;
          const end = Math.min(start + CHUNK_SIZE, file.size);

          const chunkData = file.slice(start, end);

          let formData = new FormData();
          formData.append("fileName", file.name);
          this.uploadFileName = file.name;
          formData.append("fileChunk", chunkData);
          formData.append("currentChunk", chunk);
          formData.append("totalChunks", totalChunks);

          try {
            await axiosCustom.post("yedekler/yedekyukle/", formData);
            uploadedFiles++;
            this.uploadProgress = (uploadedFiles / totalFiles) * 100;
          } catch (error) {
            console.error('Yedek yükleme hatası: ', error);
            this.$toast.error('Yedek yükleme hatası');
            // Handle error
            return;
          }
        }
      }

      // Tüm dosyaların tüm chunk'ları yüklendiyse, işlemi tamamla
      this.isUploading = false;
      this.sqlmodal = false;
      this.uploadProgress = 100;

      this.yedekyukleislem();

    },


    yedekyukleislem() {
      axiosCustom
        .get("yedekler/yedekyukleislem")
        .then(() => {

          this.$toast.success("Yedek Yüklendi ve İşlendi  Otomatik Çıkış Yapılacak");

          setTimeout(() => {
            this.$globalVariable.cikisYap();
          }, 3000);

        })
        .catch((error) => {
          console.error("Yedek  Hatası: ", error);
        });
    },











  },
};
</script>
